import { yupResolver } from '@hookform/resolvers/yup';
import { CustomButton } from '@Modules/core/components';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import React from 'react';
import { useForm } from 'react-hook-form';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { IAccountFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/account/AccountFormMeta';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import CustomFilterBtn from '@Modules/core/components/form/CustomFilterBtn';

type Props = {
  meta: IAccountFormMeta,
  [x: string]: any,
} & TFormUIProps;

const AccountFormUI: React.FC<Props> = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
  ...rest
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)} {...rest}>
      {displayCustomInputs<IAccountFormMeta>(
        meta,
        register,
        errors,
        isLoading,
        [meta.bank.name]
      )}

      <CC.SimpleGrid
        columns={{ base: 1, lg: 2 }}
        gridRowGap={4}
        columnGap={10}
        my={4}
      >
        {displayCustomInputs<IAccountFormMeta>(
          meta,
          register,
          errors,
          isLoading,
          [],
          [meta.bank.name]
        )}
      </CC.SimpleGrid>

      <CC.HStack my={4} justifyContent={'flex-end'}>
        <CustomFilterBtn isLoading={isLoading} isSubmitting={isSubmitting} />
      </CC.HStack>
    </CC.Box>
  );
};

export default AccountFormUI;
